import { createContext } from 'react';
import { AuthProfile } from '../api/types';

export interface AuthContextValue {
  user: AuthProfile | null;
  isLoading: boolean;
  login: (email: string, password: string) => Promise<void>;
  loginError: string | null;
  logout: () => Promise<void>;
}

export const AuthContext = createContext<AuthContextValue | undefined>(undefined);
